if (!customElements.get("footer-details")) {
  class FooterDetails extends AccordionDetails {
    constructor() {
      super();
    }
    
    connectedCallback() {
      this.openDefault = this.dataset.openDefault === 'true';

      // Close without the height animation: the content is already hidden by CSS until this point,
      // and animating from the open height would shift everything below on short pages.
      if (FoxTheme.config.mqlTablet && !this.openDefault) {
        this.isOpen = false;
        this.removeAttribute('open');
        this.setAttribute('aria-expanded', 'false');
      }

      document.addEventListener('matchTablet', () => {
        if (!this.openDefault) {
          this.open = false;
        } else {
          this.open = true;
        }
      });

      document.addEventListener('unmatchTablet', () => {
        this.open = true;
      });
    }
  }
  customElements.define('footer-details', FooterDetails, { extends: 'details' });
}